<template>
  <div>
    <v-list v-if="!activeDiary">
      <v-list-item v-if="shouldShowNurserySchoolDiary" @click="$emit('update:activeDiary', 'nursery')">
        <v-list-item-content>
          <div class="d-flex align-center justify-space-between">
            <div>{{ $t('others.nurseryDiary') }}</div>
            <v-icon>mdi-chevron-right</v-icon>
          </div>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>

      <v-list-item v-if="shouldShowNurseryHoursDiary" @click="$emit('update:activeDiary', 'nursery-hours')">
        <v-list-item-content>
          <div class="d-flex align-center justify-space-between">
            <div>{{ $t('others.extendedCareDiary') }}</div>
            <v-icon>mdi-chevron-right</v-icon>
          </div>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
    </v-list>

    <NurserySchoolDiaryContainer
      v-if="activeDiary === 'nursery'"
    />
    <NurseryHoursDiaryContainer
      v-if="activeDiary === 'nursery-hours'"
    />
  </div>
</template>

<script lang="ts">
//import Vue from 'vue';
import { defineComponent } from "vue";
import { MeNurserySchoolResponse, MeResponse } from 'chaild-api/lib';
import LocalDataService from '@/service/LocalDataService';
import NurserySchoolDiaryContainer from '@/container/others/NurserySchoolDiaryContainer.vue';
import NurseryHoursDiaryContainer from '@/container/others/NurseryHoursDiaryContainer.vue';

export default defineComponent({
  components: { NurserySchoolDiaryContainer, NurseryHoursDiaryContainer },
  props: {
    activeDiary: {
      type: String,
      default: null,
    },
  },
  computed: {
    me(): MeResponse | null {
      return LocalDataService.getUser();
    },
    currentSchool(): MeNurserySchoolResponse | undefined {
      if (this.me) {
        let nurserySchool = this.me.nurserySchools.find(nursery => nursery.isDefault);
        if (this.me.nurserySchools.length === 0) {
          return undefined
        }
        if (!nurserySchool) {
          nurserySchool = this.me.nurserySchools[0];
        }
        return nurserySchool;
      }
      return undefined;
    },
    features(): Array<{
      name: string; // 機能名
      slug: string; // 機能スラッグ
      isEnabled: boolean; // 機能有効フラグ
    }> {
      if (this.currentSchool) {
        const messageFeature = this.currentSchool.applicationPlan.nurseryMobile.featureGroups.find((fg) => fg.name === "設定");
        if (!messageFeature) {
          return [];
        }
        return messageFeature.features.filter((f) => f.isEnabled);
      }
      return [];
    },
    shouldShowNurserySchoolDiary() {
      return true;
      // NOTE: 設定経由で表示の切り替えをユーザーにさせる場合は以下のコードを利用する
      // const find = this.features.find((f) => f.slug === "EDIT_THIS_SLUG");
      // if (find) {
      //   return true;
      // }
      // return false;
    },
    shouldShowNurseryHoursDiary() {
      return true;
      // NOTE: 設定経由で表示の切り替えをユーザーにさせる場合は以下のコードを利用する
      // const find = this.features.find((f) => f.slug === "EDIT_THIS_SLUG");
      // if (find) {
      //   return true;
      // }
      // return false;
    },
  },
});
</script>
